import { useQuery } from "react-query";

import { UsersService } from "~/entity/Users/api/service";

/**
 * GET /user/{userId}/assignments — все закрепления пользователя
 * (постоянные + временные). Вызывается после загрузки профиля пользователя,
 * чтобы заполнить блок «Временное закрепление» существующими записями.
 */
export default function useGetUserAssignments(userId: number | string) {
  return useQuery(
    ["getUserAssignments", String(userId)],
    () => UsersService.GET.getUserAssignments(userId),
    {
      refetchOnWindowFocus: false,
      cacheTime: 0,
      enabled: !!userId,
      onError: (error) => {
        console.error("Ошибка загрузки закреплений пользователя:", error);
      },
    }
  );
}
